import { Component, Input, OnInit, input } from "@angular/core";
import { RobotRulesService, EditMode, EventType, TaskType } from "./robot-rules.service";
import _ from "lodash";
import { TranslateService } from "@root/shared/service/translate.service";

@Component({
  selector: "host-robot-rules",
  templateUrl: "./robot-rules.component.html",
  styleUrls: ["./robot-rules.component.scss"],
})
export class RobotRulesComponent implements OnInit {
  @Input() type: "message" | "rate" | "rate_reply" | "price" | "task" | "gap" = "message";
  @Input() eventType = EventType.ReplyToEvents;
  @Input() event;
  @Input() editMode: EditMode = EditMode.Create;
  @Input() id;

  /**
   * 只有在 type === task 时才传该值
   */
  @Input() taskType: TaskType = "cleaning";

  listOfChannelOption = [];
  listOfHouseOption = [];
  listOfDynContentOption = [];
  constructor(
    private robotRulesService: RobotRulesService,
    private t: TranslateService,
  ) {}

  ngOnInit() {
    this.fetchAllChannels();
    this.fetchAllHouses();
    this.fetchDynContent();

    console.log("this.type: ", this.type, " event: ", this.event, " taskType: ", this.taskType);
  }

  fetchAllChannels() {
    this.robotRulesService
      .fetchAllChannels({ from: this.type === "message" ? "message" : this.type === "price" ? "price" : "comment" })
      .subscribe((res) => {
        const channels = _.get(res, "data.had_thirdparty") || [];
        this.listOfChannelOption = channels.map((channel) => ({
          label: this.t.t("word.channel_" + channel),
          value: channel,
        }));
      });
  }

  fetchAllHouses() {
    this.robotRulesService.fetchAllHouses().subscribe((res) => {
      this.listOfHouseOption = _.get(res, "data");
    });
  }

  fetchDynContent() {
    if (this.type === "rate" || this.type === "rate_reply") {
      this.fetchRateDynContent();
    } else if (this.type === "message") {
      this.fetchMsgDynContent();
    } else if (this.type === "task") {
      this.fetchTaskDynContent();
    }
  }

  private fetchMsgDynContent() {
    this.robotRulesService.fetchMessageDynContent().subscribe((res) => {
      const map = _.get(res, "data");
      this.listOfDynContentOption = _.map(map, (value, key) => ({
        label: value,
        value: key,
      }));
      console.log("dynContent: ", this.listOfDynContentOption);
    });
  }

  private fetchRateDynContent() {
    this.robotRulesService.fetchRateDynContent().subscribe((res) => {
      const map = _.get(res, "data");
      this.listOfDynContentOption = _.map(map, (value, key) => ({
        label: value,
        value: key,
      }));
      console.log("dynContent: ", this.listOfDynContentOption);
    });
  }

  private fetchTaskDynContent() {
    this.robotRulesService.fetchTaskDynContent().subscribe((res) => {
      const map = _.get(res, "data");
      this.listOfDynContentOption = _.map(map, (value, key) => ({
        label: value,
        value: key,
      }));
    });
  }
}
